const useLoggedUser = () => {
  const loggedUser = JSON.parse(window.localStorage.getItem('loggedUser') || null);
  return {
    loggedUser,
    role: loggedUser?.role,
  };
};
export default useLoggedUser;
